

  $('.wd-menu-new-content-left-item').mouseenter(function(){
    $(this).css({'color':'#0066bd','padding':'20px 0px 20px 40px','background':'#F9FBFD',"border-radius":"12px"});
    $(this).parent('a').siblings().find('.wd-menu-new-content-left-item').css({'color':'#000','padding':'20px 0px 20px 32px','background':'#fff'});
  })
  $('.wd-menu-new-content-mid-item').mouseenter(function(){
    $(this).css({'color':'#0066bd','padding':'20px 0 20px 46px'});
    $(this).parent('a').siblings().find('.wd-menu-new-content-mid-item').css({'color':'#666','padding':'20px 10px 20px 36px'});
  })
  $('.wd-menu-new-content-mid-item').mouseleave(function(){
    $(this).css({'color':'#666','padding':'20px 10px 20px 36px'});
  })




  $('.wd-menu-new-content-left-box .wd-menu-new-content-left-box-a').mouseenter(function() {
    var i = $(this).index();
    $(this).parents('.wd-menu-new-content-left-box').siblings('.wd-menu-new-content-right-box').find('.wd-menu-new-content-product-box').hide().eq(i).stop().fadeIn();
    // $(this).parents('.wd-menu-new-content-left-box').siblings('.wd-menu-new-content-mid-box').find('.wd-menu-new-content-mid-item-all').hide().eq(i).fadeIn();
       $(this).parents('.wd-menu-new-content-left-box').siblings('.wd-menu-new-content-mid-box').hide().eq(i).fadeIn();
    $('.wd-menu-new-content-right-title-text-for').text("Waterdrop Replacement For");
    $('.wd-menu-new-content-left-box-text-uv-water-sterilizer').text("Featured Products");

  })
  $('.wd-menu-new-content-left-box-a-for').mouseenter(function() {
    $('.wd-menu-new-content-right-title-text-for').text("Waterdrop Replacement for");
  })


  $('.wd-menu-new-content-left-box-a-uv-water-sterilizer').mouseenter(function() {
    $('.wd-menu-new-content-left-box-text-uv-water-sterilizer').text("Featured Product");
  })


  $('.wd-menu-new-content-left-item').mouseenter(function(){
    var col=$(this).css("padding-left");
    if (col == "50px"){
      $('.wd-menu-new-content-left-box .wd-menu-new-content-left-box-a').mouseenter(function() {
        var i = $(this).index();
        $(this).parents('.wd-menu-new-content-left-box').siblings('.wd-menu-new-content-right-box').find('.wd-menu-new-content-product-box').eq(i).stop().css("opacity","1");
        // $(this).parents('.wd-menu-new-content-left-box').siblings('.wd-menu-new-content-mid-box').find('.wd-menu-new-content-mid-item-all').eq(i).stop().css("opacity","1");
             $(this).parents('.wd-menu-new-content-left-box').siblings('.wd-menu-new-content-mid-box').eq(i).stop().css("opacity","1");
      })

    }
  })

  $('.wd-menu-new-all-box .wd-menu-new-title-content-box').mouseenter(function() {
    $('.wd-v2-header-top').css("background-color","#fff");
    $('.wd-v2-header-top').css("background-color","#fff !important");
    $('.wd-v2-head-logo-white').addClass("wd-v2-head-logo-none");
    $('.wd-v2-head-logo-blue').addClass("wd-v2-head-logo-block")
    $('.wd-menu-new-title a').addClass("wd-v2-header-font-color")
    $(this).find('.wd-v2-header-bottom-line').addClass('wd-menu-new-title-active');
    $(this).siblings().find('.wd-menu-new-title').removeClass('wd-menu-new-title-active');
    $(this).find('.wd-v2-header-bottom-line').removeClass('wd-menu-new-title-inactive');
    $(this).find('.wd-menu-new-content').stop().fadeIn(200);
    
    $(this).siblings().find('.wd-menu-new-content').stop().fadeOut(200);
  })
  $('.wd-menu-new-title-bgc-box').mouseenter(function() {
     $(".wd-menu-new-title-bgc").fadeIn(200);
  })
  $('.wd-menu-new-title-bgc-box').mouseleave(function() {
     $(".wd-menu-new-title-bgc").fadeOut(200);
  })
  $('.wd-menu-new-all-box .wd-menu-new-title-content-box').mouseleave(function() {
    $('.wd-menu-new-title a').removeClass("wd-v2-header-font-color")
    $('.wd-v2-header-top').css("background-color","rgba(0, 0, 0, 0)");
    $('.wd-v2-head-logo-white').removeClass("wd-v2-head-logo-none");
    $('.wd-v2-head-logo-blue').removeClass("wd-v2-head-logo-block")
    
    $(this).find('.wd-v2-header-bottom-line').removeClass('wd-menu-new-title-active');
    $(this).find('.wd-v2-header-bottom-line').addClass('wd-menu-new-title-inactive');
    $(this).find('.wd-menu-new-content').stop().fadeOut(200);
    $('.wd-menu-new-content-left-box').find(".wd-menu-new-content-left-item").css({'color':'#000','padding':'20px 0px 20px 32px','background':'#fff'})
    $('.wd-menu-new-content-left-box').find('a').eq(0).find(".wd-menu-new-content-left-item").css({'color':'#0066bd','padding':'20px 0px 20px 40px','background':'#F9FBFD',"border-radius":"12px"});
    $('.wd-menu-new-content-left-box-undersink-filter').find(".wd-menu-new-content-left-item").css({'color':'#000','padding':'20px 10px 20px 32px','background':'#fff'})
    $('.wd-menu-new-content-left-box-undersink-filter').find('a').eq(0).find(".wd-menu-new-content-left-item").css({'color':'#0066bd','padding':'20px 0px 20px 40px','background':'#F9FBFD',"border-radius":"12px"});
    $('.wd-menu-new-content-left-box-all-filter').find(".wd-menu-new-content-left-item").css({'color':'#000','padding':'20px 0px 20px 32px','background':'#fff'})
    $('.wd-menu-new-content-left-box-all-filter').find('a').eq(0).find(".wd-menu-new-content-left-item").css({'color':'#0066bd','padding':'20px 0px 20px 40px','background':'#F9FBFD',"border-radius":"12px"});
    $('.wd-menu-new-content-left-box-hot-sale').find(".wd-menu-new-content-left-item").css({'color':'#000','padding':'20px 0px 20px 32px','background':'#fff'})
    $('.wd-menu-new-content-left-box-hot-sale').find('a').eq(0).find(".wd-menu-new-content-left-item").css({'color':'#0066bd','padding':'20px 0px 20px 40px','background':'#F9FBFD',"border-radius":"12px"});
    $('.wd-menu-new-content-left-box-jugs_dispensers_taps').find(".wd-menu-new-content-left-item").css({'color':'#000','padding':'20px 0px 20px 32px','background':'#fff'})
    $('.wd-menu-new-content-left-box-jugs_dispensers_taps').find('a').eq(0).find(".wd-menu-new-content-left-item").css({'color':'#0066bd','padding':'20px 0px 20px 40px','background':'#F9FBFD',"border-radius":"12px"});
    $('.wd-menu-new-content-left-box-outdoor-filters').find(".wd-menu-new-content-left-item").css({'color':'#000','padding':'20px 0px 20px 32px','background':'#fff'})
    $('.wd-menu-new-content-left-box-outdoor-filters').find('a').eq(0).find(".wd-menu-new-content-left-item").css({'color':'#0066bd','padding':'20px 0px 20px 40px','background':'#F9FBFD',"border-radius":"12px"});
    $('.wd-menu-new-content-left-box-family').find(".wd-menu-new-content-left-item").css({'color':'#000','padding':'20px 10px 20px 32px','background':'#fff'})
    $('.wd-menu-new-content-left-box-family').find('a').eq(0).find(".wd-menu-new-content-left-item").css({'color':'#0066bd','padding':'20px 0px 20px 40px','background':'#F9FBFD',"border-radius":"12px"});
    $('.wd-menu-new-content-right-title-text-for').text("Waterdrop Replacement For");

    $('.wd-wd-menu-new-content-product-box-all').find(".wd-menu-new-content-product-box").css("display","none")
    $('.wd-wd-menu-new-content-product-box-all').find('.wd-menu-new-content-product-box').eq(0).css("display","flex");
    $('.wd-wd-menu-new-content-product-box-undersink-filter').find(".wd-menu-new-content-product-box").css("display","none")
    $('.wd-wd-menu-new-content-product-box-undersink-filter').find('.wd-menu-new-content-product-box').eq(0).css("display","flex");
    $('.wd-wd-menu-new-content-product-box-all-filter').find(".wd-menu-new-content-product-box").css("display","none")
    $('.wd-wd-menu-new-content-product-box-all-filter').find('.wd-menu-new-content-product-box').eq(0).css("display","grid");
    $('.wd-wd-menu-new-content-product-box-all-hot-sale').find(".wd-menu-new-content-product-box").css("display","none")
    $('.wd-wd-menu-new-content-product-box-all-hot-sale').find('.wd-menu-new-content-product-box').eq(0).css("display","grid");
    $('.wd-wd-menu-new-content-product-box-jugs_dispensers_taps').find(".wd-menu-new-content-product-box").css("display","none")
    $('.wd-wd-menu-new-content-product-box-jugs_dispensers_taps').find('.wd-menu-new-content-product-box').eq(0).css("display","grid");
    $('.wd-wd-menu-new-content-product-box-outdoor-filters').find(".wd-menu-new-content-product-box").css("display","none")
    $('.wd-wd-menu-new-content-product-box-outdoor-filters').find('.wd-menu-new-content-product-box').eq(0).css("display","grid");
    $('.wd-wd-menu-new-content-product-box-family').find(".wd-menu-new-content-product-box").css("display","none")
    $('.wd-wd-menu-new-content-product-box-family').find('.wd-menu-new-content-product-box').eq(0).css("display","grid");
    $('.wd-menu-new-content-mid-box').find(".wd-menu-new-content-mid-item-all").css("display","none")
    $('.wd-menu-new-content-mid-box').find('.wd-menu-new-content-mid-item-all').eq(0).css("display","block");
  })
